import styled from 'styled-components'
import { GrayColor, OrangeColor } from '../../constants/constants'

const paddingLeftText = '6px'
export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 40px;
`
export const TableHeader = styled.div`
  display: inline-flex;
  flex-direction: column;
  border: 1px solid;
  border-color: ${OrangeColor};
  padding-left: ${paddingLeftText};
`
export const TableCompanyInfoWrapper = styled.div`
  display: inline-flex;
  flex-direction: row;
  border-left: 1px solid;
  border-right: 1px solid;
  border-bottom: 1px solid;
  border-color: ${OrangeColor};
  width: auto;
`

export const TableCompanyInfoColumDescription = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: ${paddingLeftText};
`

export const TableCompanyInfoColumAchievements = styled.div`
  display: flex;
  flex-direction: column;
  width: 40%;
  padding-left: ${paddingLeftText};
`

export const TableCompanyInfoColumResponsibilities = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid;
  border-color: ${OrangeColor};
  width: 60%;
  padding-left: ${paddingLeftText};
`

export const SkillsUsedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-right: 1px solid ${OrangeColor};
`
export const SkillsUsed = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid;
  // border-right: 1px solid;
  border-bottom: 1px solid;
  border-color: ${OrangeColor};
  flex-grow: 1;
  padding-left: ${paddingLeftText};
`

export const ProjectRole = styled.div`
  font-weight: bold;
  color: ${OrangeColor};
`

export const TimeAsEmployee = styled.div`
  font-weight: bold;
  font-size: 11pt;
  color: ${GrayColor};
  margin-top: 6px;
  margin-bottom: 6px;
`

export const Subtitle = styled.div`
  font-weight: bold;
  font-size: 9pt;
  margin-top: 7px;
`
export const TextDescription = styled.div`
  font-size: 9pt;
  margin-top: 5px;
  margin-bottom: 7px;
  white-space: pre-line;
  text-align: justify;
  padding: 1rem;
`

export const EmployerDescription = styled.div`
  font-size: 9pt;
  margin-top: 2px;
  margin-bottom: 2px;
`
